'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
exports.Scroll = void 0;
var gsap_1 = require("gsap");
var ScrollTrigger_1 = require("gsap/ScrollTrigger");
gsap_1.gsap.registerPlugin(ScrollTrigger_1.ScrollTrigger);
var Scroll = /** @class */ (function () {
    function Scroll() {
        gsap_1.gsap.fromTo(".bulletFadeInImage", {
            y: 100,
            opacity: 0,
        }, {
            scrollTrigger: {
                trigger: ".bulletFadeInImage",
                start: "top center",
            },
            y: 0,
            opacity: 1,
        });
    }
    return Scroll;
}());
exports.Scroll = Scroll;
exports.default = Scroll;
